import { Component, Input, DoCheck, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, AfterContentChecked } from '@angular/core';
@Component({
  selector: 'app-item-collaborator',
  templateUrl: './item-collaborator.component.html',
  styleUrls: ['./item-collaborator.component.scss']
})
export class ItemCollaboratorComponent implements DoCheck {
  static itemCounter = 0;
  @Input() isInactiveList = false;
  @Input() isRescueList = false;
  @Input() selected: boolean;
  @Input() departments: Array<any>;
  @Input() roles: Array<any>;
  @Input() units: Array<any>;
  @Input() item: any;

  @Output() selectEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  itemId = 'item-id' + ItemCollaboratorComponent.itemCounter;
  departmentName: any;
  roleName: any;
  unitName: any;
  currency = 'R$';

  constructor() {
    ItemCollaboratorComponent.itemCounter++;
  }

  ngDoCheck(): void {
    this.departmentName = this.loadDepartmentName();
    this.roleName = this.loadRoleName();
    this.unitName = this.loadUnitName();
  }

  loadUnitName(): string | any {
    if (this.units) {
      const unitUid = this.item?.unit;
      const defaultUnit = {
        code: '01',
        name: 'Default Unit',
        safedoc: '',
        uid: 'c73885d0-052a-458e-aa29-9f52470300d1'
        }
      this.units = [defaultUnit, ...this.units]
      return this.units?.filter(u => u?.uid === unitUid)[0];
    }
  }

  loadDepartmentName(): string | any {
    if (this.departments) {
      const departmentUid = this.item?.department;
      const defaultDeparment = {
      code: '01',
      name: 'Default Department',
      safedoc: '',
      uid: '89b5c543-50a0-47b3-abe4-77398b768142'
      }
      this.departments = [defaultDeparment, ...this.departments]
      return this.departments?.filter(d => d?.uid === departmentUid)[0];
    }
  }

  loadRoleName(): string | any {
    if (this.roles) {
      const roleUid = this.item?.role;
      const defaultRole = {
        code: '01',
        name: 'Default Role',
        safedoc: '',
        uid: '1412d7fa-1905-43e5-92b7-f0b2c3699875'
        }
      this.roles = [defaultRole, ...this.roles]
      return this.roles?.filter(r => r?.uid === roleUid)[0];
    }
  }

  selectItem(): void {
    this.selected = !this.selected;
    this.selectEvent.emit(this.selected);
  }
}
